
const server = {
    // baseURL:'https://local.quattropy.com/emprendimiento/s1/public/',
    // baseURL:'https://emprendimientosvirtuales.com.py/s1_cerro/public/',
    // baseURL: 'http://localhost:8091/recoleta/s1_recoleta/public/',
    baseURL: 'https://sospy.org/s1_recoleta/public/',
    urlProducto: ''
}

export default server;
